import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const sheetLabelToParam = {
  "Titles": "titles",
  "Topics, Themes, Questions A-E": "a-e",
  "Topics, Themes, Questions F-L": "f-l",
  "Topics, Themes, Questions M-R": "m-r",
  "Topics, Themes, Questions S-Z": "s-z"
};

const displayLabelOverrides = {
  "Topics, Themes, Questions A-E": "Subject Headings A-E",
  "Topics, Themes, Questions F-L": "Subject Headings F-L",
  "Topics, Themes, Questions M-R": "Subject Headings M-R",
  "Topics, Themes, Questions S-Z": "Subject Headings S-Z",
};

const paramToSheetLabel = Object.fromEntries(
  Object.entries(sheetLabelToParam).map(([label, param]) => [param, label])
);

function LibraryOfCongress() {
  const [sheetData, setSheetData] = useState({});
  const [searchParams, setSearchParams] = useSearchParams();

  const sectionParam = (searchParams.get("section") || "titles").toLowerCase();
  const activeSheet = paramToSheetLabel[sectionParam] || "Titles";
  const navigate = useNavigate();

  const handleKeywordClick = (keyword) => {
    const queryParams = new URLSearchParams({
      keyword,
      secondary_startyear: "",
      secondary_endyear: "",
      sortby: "1",
    }).toString();

    navigate(`/secondarysearch?${queryParams}`);
  };

  useEffect(() => {
    fetch("./data/loc.xls")
      .then((res) => res.arrayBuffer())
      .then((buffer) => {
        const workbook = XLSX.read(buffer, { type: "array" });
        const data = {};
        workbook.SheetNames.forEach((name) => {
          const rows = XLSX.utils.sheet_to_json(workbook.Sheets[name], { header: 1 });
          data[name] = rows;
        });
        setSheetData(data);
      });
  }, []);

  const handleTabClick = (param) => {
    setSearchParams({ section: param });
  };

  const tabLabels = Object.keys(sheetLabelToParam);

  return (
    <div className="container mt-4">
      <h1 className="page-header">Library of Congress Subject Headings</h1>
      <p>
        Click following links to search the secondary bibliography by author, Library of Congress headings, or title.
      </p>

      <ul className="nav nav-tabs" role="tablist">
        {tabLabels.map((label) => {
          const param = sheetLabelToParam[label];
          const displayLabel = displayLabelOverrides[label] || label;
          return (
            <li
              className="tab-item"
              key={label}
              onClick={() => handleTabClick(param)}
              style={{ cursor: "pointer", userSelect: "none" }}
            >
              <button className={`nav-link ${label === activeSheet ? "active" : ""}`}>
                {displayLabel}
              </button>
            </li>
          );
        })}
      </ul>
      
      <div className="tab-content mt-3">
        <div className="tab-pane fade active show">
          <h3>{activeSheet}</h3>
          {sheetData[activeSheet] && (
            <table className="table table-striped">
              <tbody>
                {sheetData[activeSheet].map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {row.map((cell, colIndex) => (
                      <td key={colIndex}>
                        {cell ? (
                          <button
                            className="link-button"
                            onClick={(e) => {
                              e.preventDefault();
                              handleKeywordClick(cell);
                            }}
                          >
                            {cell}
                          </button>
                        ) : null}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

export default LibraryOfCongress;
